<template>
    <transition name="flash">
        <a href="#" @click.prevent="stopCountdown">
        <div class="notification ck-notification-dialog" :class="type" v-show="show">
            <button class="delete" @click="hideNotification"></button>
            <div class="ck-flash" role="alert">
                <strong>{{ message }}</strong>
            </div>
        </div>
        </a>
    </transition>
</template>

<script>
    export default {
        props: ['message', 'type'],
        data() {
            return {
                show: false,
                width: 0,
                timeout: null
            }
        },
        created() {
            if (this.message) {
                setTimeout(() => {
                    this.$data.show = true;
                    this.countdownStart();
                }, 120)

            }
        },
        methods: {
            countdownStart() {
                this.$data.timeout = setTimeout(() => {
                    this.$data.show = false;
                }, 3500)
            },
            stopCountdown() {
                clearTimeout(this.$data.timeout)
            },
            hideNotification() {
                this.$data.show = false;
            }
        }
    }
</script>

<style scoped>
    .ck-notification-dialog {
        position: fixed;
        bottom: 0;
        right: 0;
        width: 50%;
        max-width: 500px;
        min-width: 300px;
    }

    .flash-enter-active, .flash-leave-active {
        transition: all 1s;
    }
    .flash-enter, .flash-leave-to /* .list-leave-active below version 2.1.8 */ {
        opacity: 0;
        transform: translateY(100px);
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckFlash.vue